import { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../context/UserContext";
import Logo from "../Logo/Logo";
import "./AuthCheck.scss";

// component's children only shown to logged-in users
const AuthCheck = ({ fallback, children }) => {
  const { user } = useContext(UserContext);

  // if the user is logged in, show children components
  if (user?.uid) {
    return children;
  }

  // if a fallback prop is provided, show fallback
  if (fallback) {
    return fallback;
  }

  // show generic "you need to login" link
  return (
    <div className="auth-check">
      <div className="auth-container">
        <Logo />
        <p className="auth-container__description">
          You must be signed in to view this content.
        </p>
        <Link className="auth-container__link" to="/login">
          Click Here to sign in
        </Link>
      </div>
    </div>
  );
};

export default AuthCheck;
